import React from "react";

export default function Web_Bootstrap() {
  return (
    <div>
      <h1>What is Bootstrap</h1>
      <p>
        Route: <code>/web/bootstrap</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
